// extracted by mini-css-extract-plugin
export default {"card-item":"Calendar_card-item__yKJbR"};